import React, { useEffect, useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

const HomeAnimation = ({ gallery, mobileGallery, desktopVideo, mobileVideo, realEstatePage }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  const [title, setTitle] = useState(false);
  const [clearTitle, setClearTitle] = useState(false);
  const [secondTitle, setSecondTitle] = useState(false);
  const [clearSecondTitle, setClearSecondTitle] = useState(false);
  const [startGalleryInterval, setStartGalleryInterval] = useState(false);

  useEffect(() => {
    const firstTimeout = setTimeout(() => {
      setShowGallery(true);
      setStartGalleryInterval(true);
    }, 8000);

    const galleryInterval = startGalleryInterval && setInterval(() => {
      // Increment the activeIndex to show the next image
      setActiveIndex((prevIndex) => (prevIndex + 1) % gallery.length);
    }, 4000); // Adjust the time interval as needed (e.g., 3000 milliseconds for 3 seconds)

    // Clear the intervals when the component is unmounted or the first timeout has finished
    return () => {
      clearInterval(galleryInterval);
      clearTimeout(firstTimeout);
    };
  }, [activeIndex, gallery.length, startGalleryInterval]);

  useEffect(() => {
    const firstTitle = setTimeout(() => {
      setTitle(true);
      document.querySelector('.header').classList.add('header--home-animation');
    }, 9000);

    // Clear the intervals when the component is unmounted or the first timeout has finished
    return () => {
      clearTimeout(firstTitle);
    };
  }, [title]);

  useEffect(() => {
    const clearTitle = setTimeout(() => {
      setClearTitle(true);
    }, 11500);

    // Clear the intervals when the component is unmounted or the first timeout has finished
    return () => {
      clearTimeout(clearTitle);
    };
  }, [clearTitle]);

  useEffect(() => {
    const secondTitle = setTimeout(() => {
      setSecondTitle(true);
    }, 12500);

    // Clear the intervals when the component is unmounted or the first timeout has finished
    return () => {
      clearTimeout(secondTitle);
    };
  }, [secondTitle]);

  useEffect(() => {
    const clearSecondTitle = setTimeout(() => {
      setClearSecondTitle(true);
    }, 15000);

    // Clear the intervals when the component is unmounted or the first timeout has finished
    return () => {
      clearTimeout(clearSecondTitle);
    };
  }, [clearSecondTitle]);

  useEffect(() => {
    const clearScroll = setTimeout(() => {

      // Check if the user has already scrolled
      if (window.scrollY > 0) {
        return;
      }
      // Select the element
      const element = document.querySelector('.full-screen-basic');
      const headerHeight = document.querySelector('.header').offsetHeight;
      
      if (element) {
        // Get the element's distance from the top of the page
        const elementTop = element.getBoundingClientRect().top + window.scrollY;
    
        // Adjust the scroll position by subtracting the header height
        const scrollPosition = elementTop - headerHeight;
    
        // Smoothly scroll to the calculated position
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      } else {
        console.error('Element with class ".full-screen-basic" not found.');
      }
    }, 18000);

    // Clear the intervals when the component is unmounted or the first timeout has finished
    return () => {
      clearTimeout(clearScroll);
    };
  }, []);

  return (
    <section className={`home-animation${realEstatePage ? ' home-animation--real' : ''}`}>
      <div className={`home-animation__video${showGallery ? ' inactive' : ''}`}>
        <video className='home-animation__video--mobile' src={mobileVideo} autoPlay muted playsInline />
        <video className='home-animation__video--desktop' src={desktopVideo} autoPlay muted playsInline />
      </div>
      <div className={`home-animation__gallery${showGallery ? ' active' : ''}`}>
        {gallery?.map((el, i) => (
          <div
            className={`home-animation__item desktop-item ${i === activeIndex ? 'active' : ''}`}
            key={i}
          >
            { el.image && 
              <GatsbyImage
                image={el.image.localFile.childImageSharp.gatsbyImageData}
                alt={el.image.altText}
              />
            }
            { el.video &&
              <video src={el.video} autoPlay muted loop playsInline />
            }
          </div>
        ))}
        {mobileGallery?.map((el, i) => (
          <div
            className={`home-animation__item mobile-item ${i === activeIndex ? 'active' : ''}`}
            key={i}
          >
            { el.image && 
              <GatsbyImage
                image={el.image.localFile.childImageSharp.gatsbyImageData}
                alt={el.image.altText}
              />
            }
            { el.video &&
              <video src={el.video} autoPlay muted loop playsInline />
            }
          </div>
        ))}
      </div>
      { realEstatePage && 
        <>
          <h1 className={`${title ? 'active' : ''}${clearSecondTitle ? ' remove' : ''}`}><div><span>The agency</span></div> <div><span>behind Australia's leading</span></div><div><span>real estate brands.</span></div></h1>
        </>
      }
      { !realEstatePage &&
        <>
          <h1 className={`${title ? 'active' : ''}${clearTitle ? ' remove' : ''}`}><div><span>We build.</span></div> <div><span>Create.</span></div> <div><span>Transform.</span></div></h1>
          <h2 className={`${secondTitle ? 'active' : ''}${clearSecondTitle ? ' remove' : ''}`}><div><span>Brand. Digital. Code.</span></div></h2>
        </>
      }
    </section>
  );
};

export default HomeAnimation;